<template>
  <vuex-table :fields="fields" table_store="core/documents/table">
    <template slot="per-page-select">
      <i-button size="large" :to="{ name: 'core.document.create' }">
        {{ $t('core.document.add_btn') }}
      </i-button>
    </template>
    <template slot="status" slot-scope="{ item }">
      <status-badge :value="item.status" />
    </template>
    <template slot="preview" slot-scope="{ item }">
      <cell-preview :item="item" />
    </template>
    <template slot="actions" slot-scope="{ item }">
      <cell-download :item="item" />
    </template>
  </vuex-table>
</template>

<script>
  import StatusBadge from './documents-table-status-badge';
  import CellPreview from './documents-table-preview';
  import CellDownload from './documents-table-download';
  export default {
    components: { StatusBadge, CellPreview, CellDownload },
    computed: {
      fields() {
        return [
          {
            key: 'preview',
            label: this.$t('core.document.field.document'),
            sortable: false,
            class: 'w-25 text-left'
          },
          {
            key: 'status',
            label: this.$t('shared.component.table.field.status'),
            sortable: false,
            class: 'w-25 text-left'
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'w-50 text-left'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: {
              width: '100px'
            }
          }
        ];
      }
    }
  };
</script>
